import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import Highlighter from "react-highlight-words";

import { ScreenContainer, Input, Table } from "components";

import { actionDocumentTypesGetAll, selectDocumentTypesState } from "./redux";

const DocumentTypesList = () => {
  const oDispatch = useDispatch();
  const { aDocumentTypes } = useSelector(selectDocumentTypesState);
  const [sFilter, setFilter] = useState("");
  const [aFilteredData, setFilteredData] = useState([]);

  useEffect(() => {
    oDispatch(actionDocumentTypesGetAll());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredData(() => {
      return aDocumentTypes?.length
        ? aDocumentTypes
          .filter(oItem => oItem.name?.toLowerCase().includes(sFilter.toLowerCase()))
          .map(oItem => ({ ...oItem, sFilter }))
        : [];
    });
  }, [aDocumentTypes, sFilter]);

  return (
    <ScreenContainer>
      <h1 className="ui-page-title self-center">
        Listado de tipos de documentos
      </h1>
      <section className="grid grid-cols-4 mt-4">
        <div className="relative col-span-4 md:col-span-1">
          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
            <FiSearch className="w-4 h-4 text-gray-400" />
          </div>
          <Input
            withoutClass
            value={sFilter}
            floatLabel={false}
            onChange={setFilter}
            placeholder="Buscar"
            containerClassName="rounded-lg overflow-hidden"
            className="ui-field-icon w-full"
          />
        </div>
      </section>
      <section className="py-5">
        <Table data-testid={"PricesTable"}>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                #
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                Nombre
              </Table.Col>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aFilteredData.length > 0 ? (
              aFilteredData.map((oItem, nIndex) => (
                <Table.Row key={oItem.id}>
                  <Table.Col
                    scope="row"
                    className="text-xs md:text-sm px-3 py-2 font-medium text-gray-800 dark:text-white whitespace-nowrap text-center"
                  >
                    {nIndex + 1}
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center">
                    <Highlighter
                      searchWords={[oItem.sFilter]}
                      autoEscape={true}
                      textToHighlight={oItem.name}
                    />
                  </Table.Col>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-3 py-2 text-center" colSpan={3}>
                  <em>
                    {sFilter.length > 0
                      ? "No se encontraron resultados"
                      : "Sin tipos de documentos registrados"}
                  </em>
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </section>
    </ScreenContainer>
  );
};

export default DocumentTypesList;
